import { ArrowRight } from "lucide-react";
import { ThreeBand } from "./ThreeBand";

const titleColors = { pink: "var(--pink)", purple: "var(--iris)", cyan: "var(--sky)" };

const cards = [
  {
    accent: "pink",
    label: "LAYER 01 · TOP SHELL",
    title: "Guaranteed. Every display shows the products customers want to see.",
    body: "We build AI replicas of your target shoppers and simulate how they navigate your store, where they look, and what triggers them to buy, before anything ships.",
    bullets: [
      "85%+ predictive accuracy validated against real shopper baselines",
      "Predict your best sellers before production",
      "Test thousands of display variations in minutes",
    ],
    cta: "Contact Us",
  },
  {
    accent: "purple",
    label: "LAYER 02 · GANACHE",
    title: "One master plan, localized for every store.",
    body: "Approve one flagship planogram, our AI instantly translates it into hundreds of store-specific layouts based on local footprint, fixtures, and sales trends.",
    bullets: [
      "Adapt to every store's unique layout automatically",
      "Optimize placement based on local sales data",
      "Update every store in minutes when inventory changes",
    ],
    cta: "Contact Us",
  },
  {
    accent: "cyan",
    label: "LAYER 03 · BOTTOM SHELL",
    title: "Real-time visibility across every store, every day.",
    body: "Store teams snap a photo on their phone, our AI checks the shelf against your brand standards instantly.",
    bullets: [
      "Instant pass/fail compliance, no manual photo audits",
      "Works on any phone, no hardware needed",
      "Monitor every store from one executive dashboard",
    ],
    cta: "Contact Us",
  },
];

export const Platform = ({ onContact }) => {
  return (
    <section className="mac-section" id="platform" data-testid="platform-section">
      <div className="mac-container" style={{ position: "relative", zIndex: 1 }}>
        <div className="mac-eyebrow-row">
          <ThreeBand />
          <p className="mac-eyebrow">THE PLATFORM</p>
        </div>

        <h2 className="mac-h2" data-testid="platform-headline" style={{ marginTop: 22, maxWidth: 900, fontSize: "clamp(28px, 3.6vw, 44px)" }}>
          Like the macaron it's named after. <span className="mac-gradient-text">Three layers, flawless balance.</span> Design with precision. Execute with confidence. Protect your revenue.
        </h2>

        <div
          className="grid gap-6 mt-12"
          style={{ gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))" }}
        >
          {cards.map((c, i) => (
            <div className={`mac-card card-${c.accent}`} key={i} data-testid={`platform-card-${i + 1}`}>
              <div className={`mac-card-bar bar-${c.accent}`} />
              <p className={`mac-layer-label label-${c.accent}`}>{c.label}</p>
              <h3 className="mac-card-title" style={{ marginTop: 16, color: titleColors[c.accent] }}>{c.title}</h3>
              <p className="mac-body" style={{ marginTop: 14, fontSize: 14 }}>{c.body}</p>

              <div className="flex flex-col gap-3" style={{ marginTop: 20 }}>
                {c.bullets.map((b, j) => {
                  const idx = b.indexOf(":");
                  const lead = idx > -1 ? b.slice(0, idx) : null;
                  const rest = idx > -1 ? b.slice(idx + 1).trim() : b;
                  return (
                    <div className="mac-feature" key={j}>
                      <span className={`dash dash-${c.accent}`} />
                      <span>
                        {lead && <strong style={{ color: "var(--cream)", fontWeight: 600 }}>{lead}: </strong>}
                        {rest}
                      </span>
                    </div>
                  );
                })}
              </div>

              <button
                className={`mac-card-link link-${c.accent}`}
                style={{ marginTop: 24 }}
                onClick={onContact}
                data-testid={`platform-card-${i + 1}-link`}
              >
                {c.cta} <ArrowRight size={13} strokeWidth={2.5} />
              </button>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
